// de_pms_groups.ts
// Tłumaczenia dla PMS.Groups.tsx

export const dePmsGroups = {

  title:       "Gruppen und Veranstaltungen",
  description: "Operative Übersicht von Gruppenreservierungen und verknüpften Veranstaltungen.",
  filters:     "Filter",
  filtersHint: "Grenzen Sie Gruppenreservierungen mit vielen Veranstaltungen schnell ein.",
  none:        "Keine",

} as const;

export default dePmsGroups;
